/* Sleep LP — Stress score pills game.
   Mirrors sleep-lp-score behavior: seal+overlay reveals on tap,
   pills auto-tease before reveal, status chip always visible. */
(function () {
  'use strict';

  function classify(count) {
    if (count <= 3) return 'safe';
    if (count <= 6) return 'risk';
    return 'burnout';
  }

  function initGame(root) {
    var game = root.querySelector('[data-ss-game]');
    if (!game) return;
    var seal = root.querySelector('[data-ss-seal]');
    var overlay = root.querySelector('[data-ss-seal-overlay]');
    var pills = game.querySelectorAll('[data-ss-pill]');
    var zoneEl = game.querySelector('[data-ss-zone]');
    var countEl = game.querySelector('[data-ss-count]');
    var msgEl = game.querySelector('[data-ss-msg]');
    var totalPills = pills.length;
    var defaultZone = zoneEl ? zoneEl.textContent : '';
    var defaultMsg = msgEl ? msgEl.innerHTML : '';

    var labels = {
      safe: game.dataset.safeLabel || 'SAFE ZONE',
      risk: game.dataset.riskLabel || 'AT-RISK',
      burnout: game.dataset.burnoutLabel || 'BURNOUT STAGE'
    };
    var msgTemplates = {
      safe: game.querySelector('[data-ss-msg-safe]'),
      risk: game.querySelector('[data-ss-msg-risk]'),
      burnout: game.querySelector('[data-ss-msg-burnout]')
    };

    function update() {
      var selected = game.querySelectorAll('[data-ss-pill].is-active');
      var count = selected.length;
      if (count === 0) {
        game.classList.remove('has-selection');
        game.dataset.zone = 'safe';
        if (zoneEl) zoneEl.textContent = labels.safe;
        if (countEl) countEl.textContent = '0/' + totalPills;
        if (msgEl && msgTemplates.safe) msgEl.innerHTML = msgTemplates.safe.innerHTML;
        return;
      }
      game.classList.add('has-selection');
      var zone = classify(count);
      game.dataset.zone = zone;
      if (zoneEl) zoneEl.textContent = labels[zone];
      if (countEl) countEl.textContent = count + '/' + totalPills;
      if (msgEl && msgTemplates[zone]) {
        msgEl.innerHTML = msgTemplates[zone].innerHTML;
      }
    }

    function resetState() {
      pills.forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-pressed', 'false');
      });
      game.classList.remove('has-selection');
      game.dataset.zone = 'safe';
      if (zoneEl) zoneEl.textContent = defaultZone || labels.safe;
      if (countEl) countEl.textContent = '0/' + totalPills;
      if (msgEl) {
        msgEl.innerHTML = (msgTemplates.safe && msgTemplates.safe.innerHTML) || defaultMsg;
      }
    }

    var teaserId = null;
    function tickTeaser() {
      var picks = 1 + Math.floor(Math.random() * pills.length);
      var indices = {};
      while (Object.keys(indices).length < picks) {
        indices[Math.floor(Math.random() * pills.length)] = true;
      }
      pills.forEach(function (p, i) {
        if (indices[i]) p.classList.add('is-active');
        else p.classList.remove('is-active');
      });
      update();
    }
    function startTeaser() {
      if (teaserId) return;
      tickTeaser();
      teaserId = setInterval(tickTeaser, 900);
    }
    function stopTeaser() {
      if (teaserId) {
        clearInterval(teaserId);
        teaserId = null;
      }
    }

    function reveal() {
      if (root.classList.contains('is-revealed')) return;
      root.classList.add('is-revealed');
      if (seal) seal.setAttribute('tabindex', '-1');
    }

    if (seal) seal.addEventListener('click', reveal);
    if (overlay) overlay.addEventListener('click', reveal);

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (!root.classList.contains('is-revealed')) return;
        if (teaserId) {
          stopTeaser();
          resetState();
        }
        pill.classList.toggle('is-active');
        pill.setAttribute('aria-pressed', pill.classList.contains('is-active') ? 'true' : 'false');
        update();
      });
    });

    if (!root.classList.contains('is-revealed')) {
      startTeaser();
    } else {
      update();
    }
  }

  function initVideo(root) {
    var btn = root.querySelector('[data-ss-play]');
    if (!btn) return;
    var modal = root.querySelector('[data-ss-modal]');
    var modalVideo = root.querySelector('[data-ss-modal-video]');
    var panel = root.querySelector('.ss-score__modal-panel');
    var closers = root.querySelectorAll('[data-ss-close]');
    var template = root.querySelector('[data-ss-full]');

    function applyOrientation(v) {
      if (!v || !panel) return;
      function set() {
        var w = v.videoWidth, h = v.videoHeight;
        if (w && h) panel.classList.toggle('is-vertical', h > w);
      }
      if (v.readyState >= 1) set();
      else v.addEventListener('loadedmetadata', set, { once: true });
    }

    function open() {
      if (!modal || !modalVideo) return;
      modalVideo.innerHTML = '';
      if (panel) panel.classList.remove('is-vertical');
      var html = template ? template.innerHTML : '';
      var src = btn.dataset.fullSrc || '';
      if (html) {
        modalVideo.innerHTML = html;
        var v = modalVideo.querySelector('video');
        if (v) { v.muted = false; v.controls = true; v.play().catch(function () {}); applyOrientation(v); }
      } else if (src) {
        var video = document.createElement('video');
        video.src = src;
        video.controls = true;
        video.autoplay = true;
        video.muted = false;
        video.playsInline = true;
        modalVideo.appendChild(video);
        applyOrientation(video);
      } else {
        return;
      }
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      if (!modal || !modalVideo) return;
      modal.hidden = true;
      modalVideo.innerHTML = '';
      if (panel) panel.classList.remove('is-vertical');
      document.body.style.overflow = '';
    }

    btn.addEventListener('click', open);
    closers.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) close();
    });
  }

  function init(root) {
    initGame(root);
    initVideo(root);
  }

  document.querySelectorAll('[data-stress-score]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-stress-score]');
    if (root) init(root);
  });
})();
